import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LogService } from 'src/app/core/logger/logger_service';
import * as uuid from 'uuid';
import { catchError } from 'rxjs/operators';
import { ReferenceService } from '../../../services/reference.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  log_uuid = uuid.v4();
  logger_text = `auth interceptor line register:[${this.log_uuid}]`
  constructor(private authService: AuthService,
    private logger: LogService,
    private referenceService : ReferenceService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const referenceUUID = this.referenceService.getReferenceUUID()
    this.logger_text = `auth interceptor line register:[${this.log_uuid}] referenceUUID:[${referenceUUID}]`
    this.logger.info(`${this.logger_text} getAccessToken Start`)
    try{
      const accessToken = this.authService.getAccessToken();
      const channelLineId = this.authService.getChannelLineId();
      const liffChannelId = this.authService.getLiffChannelId();
      if (accessToken) {
        this.logger.info(`${this.logger_text} getAccessToken success`)
        const clonedReq = req.clone({
          setHeaders: {
          //   Authorization: `Bearer ${accessToken}`,
              access_token: accessToken,
              reference_uuid: this.referenceService.getReferenceUUID(),
              channel_line_id : channelLineId || '',
              liff_channel_id : liffChannelId || ''
          },
        });
        return next.handle(clonedReq);
      } else {
        this.logger.info(`${this.logger_text} getAccessToken failed`)
        const clonedReq = req.clone({
          setHeaders: {
            reference_uuid: this.referenceService.getReferenceUUID()
          }
        })
        return next.handle(clonedReq).pipe(
          catchError((error) => {
            if(error.status !== 200){
              this.referenceService.setShowReference(true);
              this.logger.error(`${this.logger_text} catch error:${error.message}`)
            }
            return next.handle(clonedReq);
          }));
      }
    }catch(error){
      this.logger.error(`${this.logger_text} getAccessToken fatal error :${error.message}`)
      this.referenceService.setShowReference(true);
      return throwError(() => error)
    }
  }
}
